import { useEffect } from 'react';
import { getCarriersRoutine } from '@modules/tender-platform/children/tender-own/actions';
import { Dispatch } from 'redux';

export const useCarriers = (dispatch: Dispatch) => {
  useEffect(() => {
    dispatch(getCarriersRoutine({ ids: [] }));
  }, []);
};
